module.exports = __webpack_public_path__ + "media/images/applicant/img-dummy-674f6358c97002e5a4e990bebf07487f.jpg";